(function () {
  function init() {
    var footerGroup = document.querySelector('.shopify-section-group-footer-group');
    var main = document.getElementById('MainContent');
    if (!footerGroup || !main) return;

    var spacer = document.getElementById('footer-reveal-spacer');
    if (!spacer) {
      spacer = document.createElement('div');
      spacer.id = 'footer-reveal-spacer';
      spacer.setAttribute('aria-hidden', 'true');
      spacer.style.pointerEvents = 'none';
      main.appendChild(spacer);
    }

    var root = document.documentElement;
    var headerHeight = 90;
    var tall = false;
    var ticking = false;

    // Below 750px the CSS drops the curtain entirely (footer in normal flow).
    function curtainActive() {
      return window.innerWidth >= 750;
    }

    // Curtain reveal, two cases:
    //  - Footer fits in the visible viewport (below the sticky header): it is
    //    pinned to the bottom edge and simply uncovered by the spacer.
    //  - Footer is taller than that (short windows, tablets, zoom): pin it
    //    just under the header instead, uncover it the same way, and once it
    //    is fully uncovered slide it upward for the remaining scroll so every
    //    part - logo to copyright row - passes through the visible area.
    function measure() {
      var header = document.querySelector('.section-header');
      headerHeight = header ? header.getBoundingClientRect().height : 90;

      var footer = footerGroup.querySelector('.footer');
      var previous = footer ? footer.style.minHeight : '';
      if (footer) footer.style.minHeight = '0';
      var previousTransform = footerGroup.style.transform;
      footerGroup.style.transform = 'none';
      var natural = footerGroup.offsetHeight;
      footerGroup.style.transform = previousTransform;
      if (footer) footer.style.minHeight = previous;

      tall = curtainActive() && natural > window.innerHeight - headerHeight;
      root.classList.toggle('footer-reveal-tall', tall);

      if (tall) {
        footerGroup.style.top = headerHeight + 'px';
        footerGroup.style.bottom = 'auto';
      } else {
        footerGroup.style.top = '';
        footerGroup.style.bottom = '';
        footerGroup.style.transform = '';
      }
    }

    function slide() {
      ticking = false;
      if (!tall) return;
      var height = footerGroup.offsetHeight;
      var visible = window.innerHeight - headerHeight;
      var maxScroll = root.scrollHeight - window.innerHeight;
      // Scroll distance already spent inside the reveal spacer (0 .. height).
      var progress = window.scrollY - (maxScroll - height);
      var offset = Math.min(Math.max(progress - visible, 0), Math.max(height - visible, 0));
      footerGroup.style.transform = 'translate3d(0,' + -offset + 'px,0)';
    }

    function requestSlide() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(slide);
    }

    function syncHeight() {
      measure();
      spacer.style.height = footerGroup.offsetHeight + 'px';
      slide();
    }

    syncHeight();
    window.addEventListener('load', syncHeight);
    window.addEventListener('resize', syncHeight);
    window.addEventListener('scroll', requestSlide, { passive: true });
    document.addEventListener('shopify:section:load', syncHeight);
    document.addEventListener('shopify:section:unload', syncHeight);

    if (window.ResizeObserver) {
      new ResizeObserver(syncHeight).observe(footerGroup);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
